import { useMutation, useQueryClient } from '@tanstack/react-query';

import { removeDocument } from '@entities/document/api/document';

/**
 * 문서 삭제(상태 변경) Mutation
 * - 관리자 문서관리 페이지에서 선택 삭제 시 사용
 * - 성공 시 adminDocuments 쿼리 무효화
 * @param {Object} options - React Query 옵션 (onSuccess, onError 등)
 * @returns {UseMutationResult}
 */
function useRemoveDocumentMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ids) => {
      const promises = ids.map((id) => removeDocument(id));
      await Promise.all(promises);
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['adminDocuments'] });
      if (typeof options.onSuccess === 'function') {
        options.onSuccess(...args);
      }
    },
    onError: options.onError,
  });
}

export default useRemoveDocumentMutation;
